import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { HttpService } from 'app/shared/services/http.service';

import { NotificationDto, NotificationId } from '../models/notification';

@Injectable({ providedIn: 'root' })
export class NotificationGateway {
    private readonly http = inject(HttpService);

    getNotifications(): Promise<NotificationDto[]> {
        return firstValueFrom(this.http.get('/v1/notification/inbox'));
    }

    markAsRead(id: NotificationId): Promise<NotificationId> {
        return firstValueFrom(this.http.patch(`/v1/notification/inbox/${id}/read`, {}));
    }

    markAllAsRead(): Promise<void> {
        return firstValueFrom(this.http.patch('/v1/notification/inbox/read', {}));
    }
}
